import React from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  const stats = [{
    num: '25',
    title: 'Años con Herbalife',
    sub: 'Viviendo lo que enseña'
  }, {
    num: '54',
    title: 'Años de vida plena',
    sub: 'Energía, fuerza y vitalidad'
  }, {
    num: '90',
    title: 'Días de transformación',
    sub: 'Programa RenuevaTE_90'
  }, {
    num: '40+',
    title: 'La edad del poder',
    sub: 'Donde todo comienza'
  }];
  return <section className="py-24 px-6 bg-hero-gradient" data-id="element-224">
      <div className="max-w-6xl mx-auto text-center" data-id="element-225">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-playfair font-bold text-white text-3xl md:text-[42px] leading-[1.2] mb-16" data-id="element-226">
          25 Años no son un Número.
          <br data-id="element-227" />
          Son un Legado.
        </motion.h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-228">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 flex flex-col items-center justify-center" data-id="element-229">
              <span className="font-playfair font-bold text-champagne-gold text-5xl md:text-[64px] mb-2" data-id="element-230">
                {stat.num}
              </span>
              <span className="font-montserrat text-white font-semibold text-base mb-1" data-id="element-231">
                {stat.title}
              </span>
              <span className="font-montserrat text-white/60 text-xs text-center" data-id="element-232">
                {stat.sub}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}